import React, { useState } from "react";
import { IonButton, IonCard, IonContent, IonItem, IonModal, IonTextarea } from "@ionic/react";

interface Props {
    sitePhotoPath?: string;
    onSubmit: (comments: string) => void;
    onClose: () => void;
    open: boolean;
}

const EditSitePhotoModal: React.FC<Props> = ({ sitePhotoPath, open, onSubmit, onClose }) => {
    const [comments, setComments] = useState("");

    const handleClose = () => {
        setComments("");
        onClose();
    };

    return (
        <IonModal isOpen={open} onDidDismiss={handleClose}>
            <IonContent>
                <IonCard>
                    <img alt="SitePhoto" src={sitePhotoPath} />
                    <IonItem>
                        <IonTextarea
                            label="Comments"
                            value={comments}
                            placeholder="Add your comment here (Optional)"
                            onIonInput={(e) => setComments(e.target.value as string)}
                            rows={5}
                        ></IonTextarea>
                    </IonItem>
                </IonCard>
            </IonContent>
            <IonButton
                onClick={() => {
                    onSubmit(comments);
                }}
            >
                Save
            </IonButton>
        </IonModal>
    );
};

export default EditSitePhotoModal;
